import useAuth from '@components/_hooks/useAuth';
import useGlobalSettings from '@components/_hooks/useGlobalSettings';
import dynamic from 'next/dynamic';
import React from 'react';
import { useSelector } from 'react-redux';
const DashboardNavigation = dynamic(() => import('./DashboardNavigation'), {ssr: false});
const UserRequests = dynamic(() => import("../../Custom/UserRequests"), {ssr: false});
// import dashboardReducer from "@components/Redux/Dashboard/reducer";
// import dashboardSaga from "@components/Redux/Dashboard/apiSaga";
// import dashboardSagaQuotes from "@components/Redux/Dashboard/apiSagaQuote";
// import dashboardSagaOrders from "@components/Redux/Dashboard/apiSagaOrder";
// import dashboardSagaDashboard from "@components/Redux/Dashboard/apiSagaDashboard";
// import dashboardSagaSchedule from "@components/Redux/Dashboard/apiSagaSchedulePostCode";
// import dashboardSagaPreferences from "@components/Redux/Dashboard/apiSagaPreferences";
// import ReducerInit from "../Account/ReducerInit";

const DashbardAppWrapper = ({children}) => {
    const user = useSelector(state => state.authReducer.user);
    const isAuthenticated = useSelector(state => state.authReducer.isAuthenticated);
    const hasReducer = useSelector(state => typeof state.dashboardReducer !== 'undefined');
    const {getSetting} = useGlobalSettings();
    const {isAgent} = useAuth();
    
    return (
        (isAuthenticated) && (user.email_verified_at != null) ? (
            <>
                {/* <ReducerInit
                    reducers={{
                        dashboardReducer: dashboardReducer
                    }}
                    sagas={{
                        dashboardSaga: dashboardSaga,
                        dashboardSagaQuotes: dashboardSagaQuotes,
                        dashboardSagaDashboard: dashboardSagaDashboard,
                        dashboardSagaOrders: dashboardSagaOrders,
                        dashboardSagaSchedule: dashboardSagaSchedule,
                        dashboardSagaPreferences: dashboardSagaPreferences,
                    }}
                > */}
                    {hasReducer && (
                        <>
                            <UserRequests/>
                            {(getSetting('crm_type', 'default') != 'basic') || (isAgent()) ? <DashboardNavigation/> : null}
                        </>
                    )}

                {/* </ReducerInit> */}
            </>
        ) : null
    )
}

export default React.memo(DashbardAppWrapper)